import React from "react";
import ProductContainer from "./ProductContainer";
import ProductInputForm from "./ProductInputForm";

export default function Product() {
  return (
    <>
      <div className="productWrapper">
        <ProductContainer />
        <ProductInputForm />
      </div>
    </>
  );
}
